import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Card, Button, Radio, RadioGroup, FormControlLabel, Alert, Link } from "@mui/material/";
import Select from "react-select";
import { FirmReportAPI } from "API/FirmReportAPI";
import { QueryAPI } from "API/QueryAPI";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import { checkResponse, alertWarningText } from "helpers/notification";
import DatePicker from "react-multi-date-picker";
import weekends from "react-multi-date-picker/plugins/highlight_weekends";
import gregorian_tr from "helpers/gregorian_tr";
import moment from 'moment';
import { customSelectStyles, multiSelectStyles } from "style";
import "styles.css";
import {
    setStartDate, setEndDate, setDateSelectChosen, setDateVisible,
    setFirmListOptions, setFirmListData, setUserEuIdData, setFirmListSelectedOptions, setServices,
} from "features/firmReportSlice";
import { useNavigate } from "react-router-dom";
import { endDateControl } from "helpers/helper";

function FirmReport() {

    let date = new Date();

    const dateSelectValues = [
        { value: 'selectedDate', label: 'Seçili Tarih' },
        { value: 'yesterday', label: 'Bir Önceki Gün' },
        { value: 'thisWeek', label: 'Bu Hafta' },
        { value: 'thisMonth', label: 'Bu Ay' },
        { value: 'lastWeek', label: 'Son 1 Hafta' },
        { value: 'lastMonth', label: 'Son 1 Ay' }
    ];

    const startDate = useSelector(state => state.firmReport.startDate);
    const endDate = useSelector(state => state.firmReport.endDate);

    const dateSelectChosen = useSelector(state => state.firmReport.dateSelectChosen);
    const dateVisible = useSelector(state => state.firmReport.dateVisible);
    const firmListOptions = useSelector(state => state.firmReport.firmListOptions);
    const firmListData = useSelector(state => state.firmReport.firmListData);

    const firmListSelectedOptions = useSelector(state => state.firmReport.firmListSelectedOptions);
    const services = useSelector(state => state.firmReport.services);

    const [queryId, setQueryId] = useState("");
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState("");

    const [queryName, setQueryName] = useState("");

    const dispatch = useDispatch();

    const navigate = useNavigate();

    var groupId = useSelector(state => state.common.groupId);
    var userName = useSelector(state => state.common.userName);

    const getFirmList = async e => {

        const getFirmListResponse = await FirmReportAPI.GetFirmList(groupId);

        if (checkResponse(getFirmListResponse, null, "Firmaları getirme işlemi başarısız oldu.Lütfen Tekrar deneyin.")) {

            let array = [];

            getFirmListResponse.data.resultObject.map(data => {
                array.push({ value: data.custEuId, label: data.name });
            });

            dispatch(setFirmListData(array));
            dispatch(setFirmListOptions([{ value: '*', label: 'Tüm Firmalar' }, ...array]));
        }
    };

    const getUserGroupRelatedLoginName = async e => {
        if (Number(groupId) === -1) {
            const response = await FirmReportAPI.GetUserEuIdByLoginName(userName);

            if (checkResponse(response, null, "Kullanıcı bilgisi getirme işlemi başarısız oldu.Lütfen Tekrar deneyin.")
            ) {
                const currentUser = response?.data?.resultObject?.[0];

                if (currentUser) {
                    const option = {
                        value: currentUser.userEuId,
                        label: currentUser.loginName
                    };

                    dispatch(setUserEuIdData([option]));
                    
                }
            }

            return;
        }
        const getUserGroupRelatedLoginNameResponse = await FirmReportAPI.GetUserGroupRelatedLoginName(groupId);

        dispatch(setUserEuIdData(getUserGroupRelatedLoginNameResponse.data.resultObject));
    };

    const isThreeMonthsAgoDate = (date) => {
        const enteredDate = new Date(date);
        const now = new Date();

        const threeMonthsAgo = new Date(now);
        threeMonthsAgo.setMonth(now.getMonth() - 3);

        return enteredDate >= threeMonthsAgo && enteredDate <= now;
    };

    const insertQuery = async e => {

        let startDateISO = moment(startDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        let endDateISO = moment(endDateControl(endDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        let isThreeMonthsAgo = isThreeMonthsAgoDate(new Date(startDate));

        if (firmListSelectedOptions.length == 0) {
            return alertWarningText("Lütfen en az bir adet firma seçiniz!");
        }

        if (startDateISO > endDateISO) {
            alertWarningText("Lütfen geçerli bir tarih aralığı seçiniz.Bitiş tarihi başlangıç tarihinden küçük olamaz");
            return;
        }

        if (!isThreeMonthsAgo && (services.includes('BULKSMS') || services.includes('FASTSMS') || services.includes('MEDIAMOBILE'))) {
            return alertWarningText("Bulk SMS, Fast SMS ve Medya Mobil servisimize ait sadece son 3 ayın raporunu alabilmektesiniz. Daha eski kayıtlar için operasyon@codec.com.tr mail adresimize talebi iletmenizi rica ederiz.");
        }

        let selectedFirmsArr = firmListSelectedOptions.some(i => i.value === '*') ? selectedFirms(firmListData) : selectedFirms(firmListSelectedOptions);

        selectedFirmsArr.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
        });

        const servicesTemp = [...services];
        const servicesOrdered = servicesTemp.sort(compareList());

        let parameters = {
            firms: JSON.stringify(selectedFirmsArr),
            services: JSON.stringify(servicesOrdered),
            startDate: startDateISO,
            endDate: endDateISO,
            groupId: groupId
        }

        const isExistQueryResponse = await QueryAPI.IsExistQuery("firmreport", userName, parameters);

        if (isExistQueryResponse.data.resultObject.isExist) {
            alertWarningText("Talep ettiğiniz sorgu " + isExistQueryResponse.data.resultObject.queryId + " id si ile zaten var. Lütfen sorgular menüsündeki listeden kontrol ediniz.");
            return;
        }

        const insertQueryResponse = await QueryAPI.InsertQuery(
            userName,
            0,
            "firmreport",
            queryName,
            new Date(),
            parameters
        );
        if (
            checkResponse(
                insertQueryResponse,
                null,
                "Firma Raporu getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
            )
        ) {
            if (insertQueryResponse.data.resultObject !== "") {
                setQueryId(insertQueryResponse.data.resultObject);
                setShowAlert(true);
                setAlertType("success");
            }
        }
    };

    function compareList() {
        var order = { BULKSMS: 1, FASTSMS: 2, MMS: 3, BANKACILIKOTP: 4, default: Infinity };
        return (a, b) => (order[a] || order.default) - (order[b] || order.default);
    }

    function selectedFirms(optionsList) {
        let tempArr = [];

        optionsList.map(firm => {
            tempArr.push({
                custEuId: firm.value,
                name: firm.label
            });
        });

        return tempArr;
    }

    function monthDiff(dt2, dt1) {
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= (60 * 60 * 24 * 7 * 4);
        var totalMonths = Math.abs(Math.round(diff));
        if (totalMonths === 3 && dt1.getDate() < dt2.getDate()) {
            totalMonths++;
        }
        return totalMonths;
    }

    const handleServiceChange = event => {

        if (services.includes(event.target.value)) {
            dispatch(setServices(services.filter(s => s !== event.target.value)));
        }
        else {
            dispatch(setServices([...services, event.target.value]));
        }
    };

    const handleFirmChange = options => {

        if (options.some(i => i.value === '*')) {
            dispatch(setFirmListSelectedOptions(options.filter(i => i.value === '*')));
            dispatch(setFirmListOptions([]));
        }
        else {
            dispatch(setFirmListSelectedOptions(options));
            dispatch(setFirmListOptions([{ value: '*', label: 'Tüm Firmalar' }, ...firmListData]));
        }
    };

    useEffect(() => {
        switch (dateSelectChosen.value) {
            case 'selectedDate':
                dispatch(setStartDate(date.setHours(0, 0, 0)));
                dispatch(setEndDate(date.setHours(23, 59, 59)));
                dispatch(setDateVisible(true));
                break;
            case 'yesterday':
                date.setDate(date.getDate() - 1);
                dispatch(setStartDate(date.setHours(0, 0, 0)));
                dispatch(setEndDate(date.setHours(23, 59, 59)));
                dispatch(setDateVisible(false));
                break;
            case 'thisWeek':
                let diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
                date.setDate(diff);
                dispatch(setStartDate(date.setHours(0, 0, 0)));
                dispatch(setEndDate(new Date().setHours(23, 59, 59)));
                dispatch(setDateVisible(false));
                break;
            case 'thisMonth':
                dispatch(setStartDate(new Date(date.getFullYear(), date.getMonth(), 1)));
                dispatch(setEndDate(date.setHours(23, 59, 59)));
                dispatch(setDateVisible(false));
                break;
            case 'lastWeek':
                date.setDate(date.getDate() - 7);
                dispatch(setStartDate(date.setHours(0, 0, 0)));
                dispatch(setEndDate(new Date().setHours(23, 59, 59)));
                dispatch(setDateVisible(false));
                break;
            case 'lastMonth':
                date.setMonth(date.getMonth() - 1);
                dispatch(setStartDate(date.setHours(0, 0, 0)));
                dispatch(setEndDate(new Date().setHours(23, 59, 59)));
                dispatch(setDateVisible(false));
                break;
        }
    }, [dateSelectChosen]);

    useEffect(() => {
        getFirmList();
        getUserGroupRelatedLoginName();
    }, []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={2} pb={1}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                                <MDTypography variant='h6' color='white'>
                                    Firma Raporu Filtresi
                                </MDTypography>
                                <MDTypography style={{ fontSize: "13px" }} color='white'>
                                    Hesabınıza tanımlı olan Firmalardan birden fazla Firma seçerek sorgulama yapabilirsiniz.
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={2} pb={4} px={2}>
                                <Grid container spacing={10}>

                                    <Grid item xs={12} md={12} lg={6}>
                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Firma Adı:</h6>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}
                                                border={'solid #e0e0e0'} borderRadius={'6px'}>
                                                <Select isMulti menuPortalTarget={document.body}
                                                    styles={multiSelectStyles}
                                                    placeholder="" value={firmListSelectedOptions}
                                                    options={firmListOptions} onChange={handleFirmChange} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid container spacing={10}>
                                    <Grid item xs={12} md={12} lg={6}>
                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Özel Tarih Seçimi : </h6>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}
                                                border={'solid #e0e0e0'}
                                                borderRadius={'6px'}>
                                                <Select menuPortalTarget={document.body}
                                                    styles={customSelectStyles}
                                                    value={dateSelectChosen}
                                                    options={dateSelectValues} isSearchable={false} onChange={option => {
                                                        dispatch(setDateSelectChosen(option ? option : {}));
                                                    }} />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    {
                                        dateVisible ? <Grid item xs={12} md={12} lg={6}>
                                            <Grid container spacing={1} sx={style.gridStyle}>
                                                <Grid item xs={2} md={2} lg={2} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <h6>Tarih : </h6>
                                                </Grid>
                                                <Grid item xs={4} md={4} lg={4}>
                                                    <DatePicker plugins={[weekends()]} format="YYYY-MM-DD "
                                                        style={{ ...style.datepickerStyle, border: '2px solid #ccc', borderRadius: '6px', }} value={startDate} locale={gregorian_tr} onChange={value => dispatch(setStartDate(value.format("YYYY-MM-DD HH:mm:ss")))}>
                                                    </DatePicker>
                                                </Grid>
                                                <Grid item xs={4} md={4} lg={4}>
                                                    <DatePicker plugins={[weekends()]} format="YYYY-MM-DD " style={{ ...style.datepickerStyle, border: '2px solid #ccc', borderRadius: '6px', }} value={endDate} locale={gregorian_tr} onChange={value => dispatch(setEndDate(`${value.format("YYYY-MM-DD")} 23:59:59`))}>
                                                    </DatePicker>
                                                </Grid>
                                            </Grid>
                                        </Grid> : ""
                                    }
                                </Grid>

                                <Grid container spacing={10}>
                                    <Grid item xs={12} md={12} lg={6}>
                                        <Grid container spacing={0} sx={style.gridStyle}>
                                            <Grid item xs={4} md={4} lg={4}>
                                                <h6>Sorgu Adı :</h6>
                                            </Grid>
                                            <Grid item xs={8} md={8} lg={8}>
                                                <MDInput
                                                    style={{
                                                        ...style.inputStyle,
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                    }}
                                                    type='text'
                                                    value={queryName}
                                                    onChange={e => setQueryName(e.target.value)}
                                                    inputProps={{ maxLength: 100 }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={10} >
                                    <Grid item xs={2} md={2} lg={2}>
                                        <h6>Gönderim Yapılan Servisler : </h6>
                                    </Grid>
                                    <Grid item xs={10} md={10} lg={10}>
                                        <RadioGroup row aria-labelledby='demo-row-radio-buttons-group-label' name='row-radio-buttons-group'>
                                            <FormControlLabel value='BULKSMS' control={<Radio checked={services.includes('BULKSMS')} onClick={handleServiceChange} />} label='BULK SMS' />
                                            <FormControlLabel value='FASTSMS' control={<Radio checked={services.includes('FASTSMS')} onClick={handleServiceChange} />} label='FAST SMS' />
                                            <FormControlLabel value='MMS' control={<Radio checked={services.includes('MMS')} onClick={handleServiceChange} />} label='MMS' />
                                            <FormControlLabel value='BANKACILIKOTP' control={<Radio checked={services.includes('BANKACILIKOTP')} onClick={handleServiceChange} />} label='Bankacılık OTP' />
                                        </RadioGroup>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={10}>
                                    <Grid item xs={12} md={12} lg={12} sx={{ marginTop: 2, marginBottom: 2 }}>
                                        <p style={{ fontSize: "13px", color: "red" }}>
                                            Bulk SMS, Fast SMS ve Medya Mobil servisimize ait sadece son <span style={{ fontWeight: "bold", textDecorationLine: 'underline' }}>3 ayın</span> raporunu alabilmektesiniz. Daha eski kayıtlar için <span style={{ fontWeight: "bold", textDecorationLine: 'underline' }}>operasyon@codec.com.tr</span> mail adresimize talebi iletmenizi rica ederiz.
                                        </p>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={10}>
                                    <Grid item xs={12} md={12} lg={12} sx={style.gridStyle}>
                                        <Button style={style.buttonStyle} onClick={insertQuery}>
                                            Sorgu Talebi Oluştur
                                        </Button>
                                    </Grid>
                                </Grid>

                                {showAlert ? <Grid container spacing={0} sx={style.gridStyle}>
                                    <Grid item xs={12} md={12} lg={12}>

                                        <Alert
                                            severity="success"
                                            sx={{
                                                marginLeft: "30px",
                                                backgroundColor: "#d8f4da",
                                                display: "flex",
                                                alignItems: "center",
                                                flexWrap: "wrap",
                                                gap: "4px"
                                            }}
                                        >
                                            Sorgunuz <b>{queryId}</b> id si ile işleme alınmıştır.
                                            <b>Sorgular</b> ekranından görüntüleyebilirsiniz.
                                            <Button
                                                size="small"
                                                sx={{
                                                    marginLeft: "10px",
                                                    marginRight: "6px",
                                                    textTransform: "none",
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                    color: "#000",
                                                    backgroundColor: "#bfe8c6",
                                                    border: "1px solid #6fbf7f",
                                                    borderRadius: "8px",
                                                    padding: "2px 10px",
                                                    minHeight: "26px",

                                                    "&:hover": {
                                                        backgroundColor: "#aee0b7"
                                                    }
                                                }}
                                                onClick={() => navigate("/Sorgular", { state: { queryId } })}
                                            >
                                                Sorguyu Aç
                                            </Button>
                                        </Alert>
                                    </Grid>
                                </Grid> : ""}

                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default FirmReport;